module.exports = __webpack_public_path__ + "static/alexander-2e36ad65980896453784d46beb7ce7ac.png";